(function () {
    'use strict';

    angular
        .module('app')
        .controller('GameBundlesController', GameBundlesController);

    GameBundlesController.$inject = ['$state',];

    function GameBundlesController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'game-bundles') {
                $state.go('game-bundles.list');
            }
        }
    }
})();